module.exports = {
  createCompany: 'Şirket Oluştur',
  createCatalog: 'Katalog Oluştur',
  edit: 'Düzenle',
  activate: 'Etkinleştirmek',
  deactivate: 'Devre dışı bırakmak',
  cancel: 'iptal etmek',
  create: 'Yaratmak',
  update: 'Güncelleştirme',
  submit: 'Gönder',
};



// WEBPACK FOOTER //
// ./src/lang/tr/actions.js